import {
  compose,
  dropLastWhile,
  split,
  filter,
  contains,
  replace,
  any,
  map,
  toLower,
  take,
  isNil,
  all,
  pickBy,
  head,
  tail,
  concat,
  toUpper
} from 'ramda';

import { complexMakesList, knownMakesList } from './MakesList';
import { featuresList } from './FeaturesList';
import { knownColors } from './KnownColors';
import { knownBodystyles } from './KnownBodyStyles';

import {
  regexMatchUrlWithLocation,
  regexMatchUrlWithLocationNoState,
  regexUrl,
  yearRegex,
  endsWithStateRegex
} from './constants';

const removeDashes = replace(/-/g, '');

const mapComplexSimple = x => ({ complex: x, simplified: removeDashes(x) });

export const complexMakes = complexMakesList.map(mapComplexSimple);

export const complexFeatures = featuresList.map(mapComplexSimple);

const knownMakes = [...complexMakes.map(x => x.simplified), ...knownMakesList];

// filters
export const recordsWithValue = filter(x => x && x.value);
export const removeNilProps = compose(map(pickBy(x => !isNil(x))));

// predicates
const isSlash = x => x === '/';
const isDash = x => x === '-';

export const hasLocationInUrl = url => {
  const found =
    url &&
    (url.match(regexMatchUrlWithLocation) ||
      url.match(regexMatchUrlWithLocationNoState));

  if (found?.length === 5) {
    return true;
  }

  return false;
};

export const isResultLocationOnly = all(x => x.isLocation);

// actions
export const trimTrailingSlash = dropLastWhile(isSlash);
export const trimTrailingDash = dropLastWhile(isDash);
export const capitalizeWords = map(s => concat(toUpper(head(s)), toLower(tail(s))));

// parsing
const getFirstItem = x => x[0];

export const splitDash = split('-');
export const splitQuestion = split('?');
export const splitFilters = split('filters/');

const removeQueryString = compose(
  getFirstItem,
  take(1),
  splitQuestion
);

const removeFilters = compose(
  getFirstItem,
  take(1),
  splitFilters
);

export const removeNonRelevantUrlPortions = compose(
  removeFilters,
  removeQueryString
);

const toSimple = x => replace(x.complex, x.simplified);

const simplifyPipe = compose(map(toSimple));

export const fastNormalizeUrl = compose(
  trimTrailingSlash,
  ...simplifyPipe(complexMakes),
  ...simplifyPipe(complexFeatures),
  toLower,
  removeNonRelevantUrlPortions
);

// more predicates
const isMake = term => contains(term, knownMakes);

export const isSmartMatch = url => regexUrl.test(fastNormalizeUrl(url));
export const urlEndsWithState = url => endsWithStateRegex.test(fastNormalizeUrl(url));
export const isColor = term => contains(term, knownColors);
export const isYear = term => term && yearRegex.test(term);
export const isBodyStyle = term => term && contains(term, knownBodystyles);
export const canBeIdentifiedAsTaxonomy = any(x => isMake(x.value));
export const skipValue = term => term === 'in' || term === 'with';
